import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { CommandItemComponent } from './command-item/command-item.component';
import { CommandPropertiesComponent } from './command-properties/command-properties.component';
import { AutomationComponent } from './automation.component';

@NgModule({
    imports: [SharedModule],
    declarations: [
        CommandItemComponent,
        CommandPropertiesComponent,
        AutomationComponent
    ],
    entryComponents: [AutomationComponent],
    exports: [AutomationComponent]
})
export class AutomationModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/automation/automation.module.ts